<div class="container list-options-editor">
    <lib-generic-type-ahead-multiselect
        [selectedItems]="listSelectedOptions"
        (selectedItemsChange)="onListSelectedOptionsChange($event)"
        [config]="{
            defaultText: 'Select ' + label,
            itemDisplayKey: 'name'
        }"
        [placeholder]="'Add ' + label"
        [isReadOnly]="isReadOnly"
        [allowToSaveNewItem]="true"
        [error]="!isValid"
        [showOptions]="false"
    >
    </lib-generic-type-ahead-multiselect>
    <app-validation-error-message [show]="!isValid" [errors]="validationErrors"></app-validation-error-message>
</div>
